export enum RewardShopTypeEnum {
  BONUS = 'bonus',
  BOOSTER = 'booster',
  EXTERNAL = 'external_product',
  XP = 'xp',
  PRIZESHARK = 'prizeshark',
}
